// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"XC-z","error":"YC-z","disabled":"ZC-z"};